/**
 * El contrato de salto entre módulos (docs/FASE-7.md §8).
 *
 * El launcher sabe a qué organización quiere entrar el usuario; el módulo, al arrancar, no. El
 * puente es un único parámetro de query:
 *
 *     https://cmms.continnua.com/?cnt_org=depilab
 *
 * Quien salta lo añade; quien recibe, si usa este paquete, lo lee y lo pasa como `org_hint`, de modo
 * que el IdP resuelve la organización sin preguntar. **Y quien no lo entienda, lo ignora**: el
 * usuario elige organización en el IdP, un clic de más y no un error. Esa degradación es lo que
 * permite entregar la fase sin tocar los cuatro módulos.
 *
 * El valor es el **slug**, no el uuid, porque es lo que `org_hint` espera en el núcleo.
 */
/** Prefijo `cnt_` para no chocar con los parámetros propios del módulo. */
export const ORG_QUERY_PARAM = "cnt_org";
/** Lee el slug de organización de una URL. `null` si no viene o no parece un slug. */
export function readOrgFromUrl(rawUrl) {
    try {
        const value = new URL(rawUrl, "http://localhost").searchParams.get(ORG_QUERY_PARAM);
        if (value === null)
            return null;
        const slug = value.trim().toLowerCase();
        // Mismo formato que `PATTERNS.ORG_SLUG` del núcleo. Un valor que no lo cumple se ignora en vez
        // de viajar hasta el IdP: un `org_hint` inventado no abre ninguna puerta, pero tampoco hay
        // motivo para reenviarlo.
        return /^[a-z0-9][a-z0-9-]{1,62}[a-z0-9]$/.test(slug) ? slug : null;
    }
    catch {
        return null;
    }
}
/** Añade el parámetro a la URL de un módulo. Lo usa el launcher para construir cada enlace. */
export function withOrgParam(baseUrl, orgSlug) {
    try {
        const url = new URL(baseUrl);
        url.searchParams.set(ORG_QUERY_PARAM, orgSlug);
        return url.toString();
    }
    catch {
        return baseUrl;
    }
}
//# sourceMappingURL=org-link.js.map